"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberMapMutator = void 0;
exports.stateMutator = stateMutator;
/** given definition of how to mutate a map of values, plus  the original values, continues to return a iterated mutated version of the map */
function* stateMutator(numberMapMutator) {
    let err = null;
    do {
        try {
            yield numberMapMutator.getNext();
        }
        catch (e) {
            err = e;
            console.log('Error in stateMutator', e.message);
        }
    } while (!err);
}
/** used to inject a definition of how to modifiy a state map (of numbers or null based on timestamp, and or iteration number) into the stateMutator iterator functions */
class NumberMapMutator {
    constructor({ initialTimestamp, nextTimestampFn, mutatorMap, initialIteration = 0 }) {
        this.iterate = () => Object.entries(this.mutator).forEach(([k, { val, mutator }]) => {
            this.mutator[k].val = mutator({ previousVal: val, iteration: this.iteration, timestamp: this.currentTimestamp });
        });
        this.getValueMap = () => Object.fromEntries(Object.entries(this.mutator).map(([k, { val }]) => [k, val]));
        this.getNext = () => {
            this.iterate();
            const currentMap = this.getValueMap();
            this.currentTimestamp = this.nextTimestampFn(this.currentTimestamp);
            this.iteration++;
            const state = {
                timestamp: this.currentTimestamp,
                state: currentMap,
            };
            return state;
        };
        this.currentTimestamp = initialTimestamp;
        this.nextTimestampFn = nextTimestampFn;
        this.mutator = mutatorMap;
        this.iteration = initialIteration;
    }
}
exports.NumberMapMutator = NumberMapMutator;
